import React, { Component } from 'react';
import HomePanel from '../HomePanel';
import {withRouter} from 'react-router-dom';
import { isUserLoggedIn } from '../../service/UserService';
import {Helmet} from "react-helmet";

class ItemPage1 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    register(id){
        if(isUserLoggedIn()){
            this.props.history.push("/termekregisztracio?termek="+id);
        }
        else{
            this.props.history.push("/regisztracio");
        }
    }
    render() { 
        return ( 
            <div className="kwizda-itempage-container">
                <Helmet>
                    <meta 
                        name="title"
                        content="Leanderen kártevők elleni kísérlet"
                    />
                    <meta name="description" content="Leanderen kártevők elleni kísérlet" />
                    <meta name="keywords" content="nagy termés, kötődés, terméskötődés, termés növelés, biostimulátor, foszfor, bór, alga, paradicsom, biológiai, tesztelje ingyen, regisztráció, biológiai, biológiai gazdálkodás" />
                </Helmet>
                <div className="kwizda-itempage">
                    <h2>Leanderen kártevők elleni kísérlet</h2>
                    <div>
                        <br/>A kísérlet témája a Boraqua narancsolajos készítmény és egy általánosan használt konvencionális, olajos rovarölőszer hatásának vizsgálata a leanderen előforduló levéltetvekre. 
                        <br/>A leander az egyik leggyakrabban ültetett dézsás virágzó cserje a díszkertekben. Időszakosan nagyon elszaporodnak rajta a levéltetvek, amelyek elcsúfítják a hajtásokat és legyengítik a növényt, amely így kevesebb virágot és hajtást nevel.
                        <br/>Most összevetjük, hogy a hagyományos olajos permetszerek és az új, biológiai illóolajos készítmények milyen hatással vannak a levéltetvekre a leandereken.<br/>
                        <br/>
                        <b>A kísérlet lényege, hogy nyomon követjük a levéltetvek jelenlétét, szaporodását, és csökkenésüket,  ezt fotókkal dokumentáljuk, kiértékeljük és megosztjuk.</b>
                    </div>
                    <h3>Szakmai feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az „on-garden” kísérletben 500 ml Boraqua narancsolajos készítményt és 500 ml hagyományos olajos rovarölő szert küldünk ki a résztvevőknek.
                        <br/>A kísérletben 2 db egymáshoz nagyon hasonló, 100-150 cm magasságú, dézsás (mobilizálható) leandernek kell szerepelnie, amelyek nem kaptak kezelést teleltetés után. Először úgy kell tartani őket, hogy összeérjenek.
                        <br/>A kísérlet akkor kezdődik, amikor megjelennek az első tetvek.
                        <br/>Ezt követően a két növényt legalább 5 méterre kell tenni egymástól, a beszóródás megakadályozása miatt. Figyelni kell, hogy a környezeti tényezők továbbra is megegyezzenek (benapozottság, vízellátás)
                        <br/>A kísérlet a levéltetvek észlelése után permetezéssel kezdődik és rá 4 héttel, fotózással ér véget. A fotózáskor mindig ugyanazokat a hajtásvégeket, ugyanabból a szögből és távolságról kérjük fotózni, hogy később összehasonlíthatók legyenek. Olyan hajtásokat kell kiválasztani, amelyeken jól látható az erős tetűborítottság.
                        <br/>Az <b>A növényt</b> 50 ml/10 liter víz dózisú Boraqua narancsolajos készítménnyel 2 hetente, összesen 2 alkalommal. A <b>B növényt</b> ugyanúgy, de hagyományos olajos rovarölővel permetezzük. 
                        <br/>Semmilyen más rovarölő szer, nem használható a kísérlet során. Más típusú kezelések (gombák ellen és tápanyagok) elvégezhetők, de teljesen azonosan a két növényen.
                        <br/>A kísérlet akkor minősül sikeresnek, ha kiindulásként, dokumentáltan azonosan levéltetűvel borított volt mindkét növény, majd minden kezelést és fotózást a kért módon elvégeztek.
                        <br/>A kísérlet meghiúsulása esetén nem küldünk a leírásban szereplő ajándékot.
                    </div>
                    <h3>Dokumentációs feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az első kezeléstől a következő időszakonként kérünk dokumentáló fotókat.<br/>
                        <br/><b>1. fotó:</b> Kiindulási állapot. Mindkét növényről, 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>
                        <br/><b>2. fotó:</b> 2 héttel később Mindkét növényről, ugyanabban a szögben és távolságról kérünk, ugyanazokról 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>
                        <br/><b>3. fotó:</b> 2 héttel később Mindkét növényről, ugyanabban a szögben és távolságról kérünk ugyanazokról 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>   
                        <br/>A fotók küldése során legyen egyértelműen feltüntetve, melyik az A növény fotója és melyik a B növény fotója!
                        <br/>A fotókat minden héten hétfőn reggel 8-ig kérjük emailben megküldeni a <a className='kwizda3-link' href='mailto:marketing@muchmore.hu'>marketing@muchmore.hu</a> email címre.

                        <div style={{marginTop:30}}>
                            <img alt="cimke" style={{display:'inline-block', width:'25%'}} src="img/kwizda3_cimkek/nezzuk_kiserletek_thumbnail_web_leander.png"></img>
                            <img alt="kepseged" style={{display:'inline-block', width:'75%'}} src="img/kwizda3_fotoseged/web_leander_kepseged.png"></img>
                        </div>
                    </div>
                    <h3>Nevezési feltételek:</h3>
                    <div>
                        Regisztráció a nezzukbioban.hu oldalon
                        <br/><b>Itt meg kell adni az elérhetőséget és a kísérlet helyét.</b>
                        <br/><b>Kérünk fotót a leanderekről és közvetlen környezetükről.</b>
                        <br/>A jelentkezők közül 4 kertészt választunk ki. A döntésnél a kísérletben szereplő leanderek méretét, állapotát és a beszóródás elleni védelem megoldhatóságát vesszük figyelembe.
                        <br/>
                        <br/><b>A kiválasztott kertészeket emailben értesítjük.</b>
                        <br/>
                        <br/><b>Garantált nyeremény egy sikeresen dokumentált kísérlet után:</b>
                        <ul>
                            <li>1 db Biopázsit 3 in 1 mikrobiológiai terméktrió</li>
                        </ul>
                        <br/>A kísérlet akkor értékelhető sikeresnek, ha kiinduláskor dokumentált volt a levéltetű fertőzés, a kezelések megtörténtek, beazonosíthatók a növények és minden héten megkapjuk a kért minőségű fotókat.
                        <br/>Ebben az esetben az ajándékokat a kísérlet befejeződése utáni két héten belül postán küldjük meg a résztvevőknek a regisztráció során megadott címre.
                        <br/>
                        <br/><b>Tartson velünk! </b>
                        <br/><b>Nézzük együtt milyen hatással vannak a kártevőkre a régi olajos rovarölő szerek és a modern illóolajos biológiai készítmények!</b>
                    </div>
                    <br/>
                    <div className="kwizda-itempage-table-div">
                            <table className="kwizda-itempage-table">
                                <thead>
                                    <tr>
                                        <th>Nevezési határidő:</th>
                                        <th>Kísérlet megvalósítás időzítése: </th>
                                        <th>Megvalósítás helye: </th>
                                        <th>Helyszínek száma:</th>
                                        <th>Dokumentáció módja:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2025. 06. 15.</td>
                                        <td>2025 07-08 között</td>
                                        <td>Dézsás növényeken, szabadban</td>
                                        <td>Maximum 4 helyszínen</td>
                                        <td>Fotók küldése emailcímre</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <br/>
                <HomePanel isItemPage={true} register={()=>this.register(1)}></HomePanel>
            </div>
         );
    }
}

export default withRouter(ItemPage1);